import React, { useEffect, useState } from 'react';
import { DadosAbaSumario, TipoDemanda, getDemanda, getSumario } from '@app/api/demanda';
import { Card, Collapse, Icon, Row, Col, Input } from 'antd';
import { dadosGeraisState, demandaIdState, desabilitarAcoesState, ordemCompraIdState } from '../atoms';
import { useRecoilValue } from 'recoil';
import { isValidGuid } from '@app/helpers/geradorGuid';
import { isObjNotEmpty } from '@app/helpers/objHelper';
import { FormSelect, MasterDetailForm, Widget } from '@digital/ui';
import moment from 'moment';
import { dateFormat } from '@app/helpers/dateTimeFormats';
import { hasPermission } from '@app/helpers/permissions';
import { getAllCompradores, updateUsuarioCompradorOrdemCompra } from '@app/api/sas/ordemCompra';
import ButtonModalCancelarOc from './ButtonModalCancelarOc';
import { getLoggedId } from '@app/helpers';

type CaracterizaçãoGeralDemandaProps = {
  sumarioData: any;
  span: number;
  order: number;
};

const CaracterizaçãoGeralDemandaFaturamentoDireto = ({ sumarioData, span, order }: CaracterizaçãoGeralDemandaProps) => {
  return (
    <Col span={span} order={order}>
      <Card title="Caracterização Geral da Demanda" className="card-sumario">
        <Row gutter={16}>
          <Col span={8}>
            <div className="content">
              <span className="card-list">
                <span className="card-list-title w30">Tipo: </span>
                <span className="card-list-content w70">{TipoDemanda[sumarioData.tipo]}</span>
              </span>
              <hr />
              <span className="card-list">
                <span className="card-list-title w60">Tipo de Aditivo: </span>
                <span className="card-list-content w40">{sumarioData.tipoAditivo}</span>
              </span>
              <hr />
              <span className="card-list">
                <span className="card-list-title w60">Tipo de Contrato: </span>
                <span className="card-list-content w40">{sumarioData.tipoContrato}</span>
              </span>
              <hr />
              <span className="card-list">
                <span className="card-list-title w40">N° Contrato: </span>
                <span className="card-list-content w60">{sumarioData.contrato != sumarioData.contratoGuardaChuva ? sumarioData.contrato : ''}</span>
              </span>
              <hr />
              <span className="card-list">
                <span className="card-list-title w40">N° PCS: </span>
                <span className="card-list-content w60">{sumarioData.numeroContratoPcs}</span>
              </span>
                            <hr />
                <span className="card-list">
                <span className="card-list-title w40">N° Contrato Original: </span>
                <span className="card-list-content w60">{sumarioData.contratoGuardaChuva}</span>
              </span>
            
            </div>
          </Col>
          <Col span={8}>
            <div className="content">
              <span className="card-list">
                <span className="card-list-title w40">Tipo de Serviço: </span>
                <span className="card-list-content w60">{sumarioData.tipoServico}</span>
              </span>
              <hr />
              
            </div>
          </Col>
          <Col span={8}>
            <div className="content">
              <span className="card-list">
                <span className="card-list-title w60">Prazo Aditivo: </span>
                <span className="card-list-content w40">
                  {sumarioData.prazoAditivo ? moment(sumarioData.prazoAditivo).format(dateFormat) : 'N/A'}
                </span>
              </span>
              <hr />
              <span className="card-list">
                <span className="card-list-title w80">Prazo Acumulado (Meses): </span>
                <span className="card-list-content w20">{sumarioData.vigencia}</span>
              </span>
              <hr />
            </div>
          </Col>
        </Row>
        <Row gutter={16}>
          <div className="content-footer">
            <hr />
            <span className="card-list">
              <span className="card-list-title">Fornecedor Contrato Original: </span>
              <span className="card-list-text">{sumarioData.fornecedorContratoOriginal}</span>
            </span>
            <hr />
            <span className="card-list">
              <span className="card-list-title">Objeto: </span>
              <span className="card-list-text">{sumarioData.objeto}</span>
            </span>
            <hr />
            <span className="card-list">
              <span className="card-list-title">Justificativa: </span>
              <span className="card-list-text">{sumarioData.justificativa}</span>
            </span>
          </div>
        </Row>
      </Card>
    </Col>
  );
};

export default CaracterizaçãoGeralDemandaFaturamentoDireto;
